import * as React from 'react';
import { IOktaMfaModel } from './Model';
import YubicoVerify from './YubicoVerify';

interface IYubicoSetupProps {
    okta: IOktaMfaModel;
    onClick: () => void;
    enrollState: {
        isEnrollSelected: boolean;
        enrollFactor: string;
    };
}

/*
 * This component will be used during enrollment process where
 * user is shown multiple factors to enroll into. Every Factor
 * will have its setup component
 */
class YubicoSetup extends React.Component<IYubicoSetupProps> {
    render() {
        const { state, strings } = this.props.okta.oktaMfa;
        let setupPage;
        const setUpPageTitle = strings.factorEnrollmentTitle.replace('[FACTOR_NAME]', strings.yubicoOtpFactor);

        const hasYubico = state.factorsForEnrollment.indexOf('yubico_otp') != -1;

        if (hasYubico && this.props.enrollState.isEnrollSelected) {
            setupPage = (
                <div>
                    <h2>{setUpPageTitle}</h2>
                    <YubicoVerify okta={this.props.okta} />
                </div>
            );
        } else {
            const val = hasYubico
                ? strings.yubicoOtpFactor
                : strings.enrolledFactor.replace('[FACTOR_NAME]', strings.yubicoOtpFactor);
            const btnClass = !hasYubico
                ? 'apmui-button apmui-button-submit apmui-button-long apmui-button-disabled'
                : 'apmui-button apmui-button-submit apmui-button-long';
            setupPage = (
                <div>
                    <span className="button-container">
                        <input
                            type="submit"
                            className={btnClass}
                            value={val}
                            disabled={!hasYubico}
                            onClick={this.props.onClick}
                        />
                    </span>
                </div>
            );
        }

        return <div>{setupPage}</div>;
    }
}

export default YubicoSetup;
